import {omit} from 'lodash';
import {API_DATA_LOADED, INIT_DB, COMMIT_DB} from './actions';
import {FILTERS_TO_LOAD_RESET} from '../../appActions';

function isApiObject(value) {
    return typeof value === 'object' && typeof value.object === 'string';
}

/**
 * Recursive parse data.
 * Supports for now:
 * Object, List
 *
 * @param data - data from api response or nested data
 * @param session redux-orm session object
 * @param registry redux-orm registry object
 */
function parseObject(data, session, registry) {
    Object.keys(registry).forEach((k) => {
        const model = registry[k];
        if ( model.modelName.toLowerCase() === data.object ) {
            const sessionModel = session[model.modelName];
            if ( sessionModel.hasId(data.id)) {
                sessionModel.withId(data.id).update(omit(data, ['id']));
            } else {
                sessionModel.create(data);
            }
        }
    });

    Object.keys(data).forEach((k) => {
        if ( Array.isArray(data[k]) ) {
            parseList(data[k], session, registry);
        }
    });
}

function parseList(data, session, registry) {
    data.forEach( (item) => {
        parse(item, session, registry);
    });
}

function parse(data, session, registry) {
    if ( isApiObject(data) ) {
        parseObject(data, session, registry);
    } else if( Array.isArray(data) ) {
        parseList(data, session, registry);
    }
}


export function dbReducer(dbState = null, action) {
    switch (action.type) {
        case INIT_DB:
            return {...action.value};
        case API_DATA_LOADED: {
            const orm = action.value.orm;
            const data = action.value.data;
            let registry = orm.registry;
    
            if (dbState === null) {
                dbState = orm.getEmptyState();
            }
            let session = orm.session({...dbState});
    
            parse(data, session, registry);
            return {...session.state};
        }
        case COMMIT_DB:
            return {
                ...action.value
            };

        case FILTERS_TO_LOAD_RESET: {
                const orm = action.value.orm;
                const data = action.value.data;
                let registry = orm.registry;
                
                let dbState = orm.getEmptyState();
                let session = orm.session({...dbState});
                parse(data, session, registry);
                return {...session.state};
            }
        default:
            return {...dbState};
    }
}



// WEBPACK FOOTER //
// ./src/lib/worm/reducers.js